// extracted by mini-css-extract-plugin
module.exports = {"instructionsContainer":"Upload_instructionsContainer__j9zWY","uploadContainer":"Upload_uploadContainer__3XRM6","uploadedFileContainer":"Upload_uploadedFileContainer__3lZRt"};